import { removeToken, getToken } from '../utils/token';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const axiosClient = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
})

axiosClient.interceptors.request.use(async (config) => {
  let token = null

  token = getToken('penatoken');

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
})

axiosClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error?.response?.status === 401) {
      removeToken();
    }
    if (error?.response?.status === 404) {
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

export default axiosClient
